import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ShieldBan, Gavel, Clock, Flame } from "lucide-react";

const StatItem = ({ icon: Icon, label, value, color, testid }) => (
  <div
    data-testid={testid}
    className="flex items-center gap-4 rounded-xl border border-[#1E293F] bg-[#0F1424]/70 px-5 py-4 backdrop-blur"
  >
    <div
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg"
      style={{ backgroundColor: `${color}18`, color }}
    >
      <Icon size={20} />
    </div>
    <div>
      <div className="font-heading text-2xl font-black leading-none tracking-tight" style={{ color }}>
        {value.toLocaleString()}
      </div>
      <div className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">{label}</div>
    </div>
  </div>
);

export const StatsBar = ({ refreshKey }) => {
  const [stats, setStats] = useState({ total_vetted: 0, banned: 0, pending: 0, community_upvotes: 0 });

  useEffect(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, [refreshKey]);

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="stats-bar">
      <StatItem icon={ShieldBan} label="Cheaters Vetted" value={stats.total_vetted} color="#00F0FF" testid="stat-vetted" />
      <StatItem icon={Gavel} label="Confirmed Cheaters" value={stats.banned} color="#FF2A55" testid="stat-banned" />
      <StatItem icon={Clock} label="Under Review" value={stats.pending} color="#FFB800" testid="stat-pending" />
      <StatItem icon={Flame} label="Community Upvotes" value={stats.community_upvotes} color="#FF2A55" testid="stat-upvotes" />
    </div>
  );
};
